(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('RoomCost', RoomCost);

    RoomCost.$inject = ['$resource'];

    function RoomCost ($resource) {
        var resourceUrl =  'api/room-costs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
